import * as React from 'react'
import { connect } from 'react-redux'
import { MainMenu } from './mainmenu/menu'
import { HubItem } from '../reducers/hub'
import { hubSelector, currentHubSelector } from '../selectors/hub'
import { RootState } from '../types/rootstate'
import { resizingComponent } from './resizingcomponent'

interface StateProps {
  hub: HubItem[]
  currentHubItem: HubItem
  streamStatus: string
}

interface DispatchProps {
}

interface OwnProps {
  name: string
  extraCssClasses?: string[]
}

type DetailsProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state: RootState): StateProps {
  return {
    hub: hubSelector(state),
    currentHubItem: currentHubSelector(state),
    streamStatus: state.stream.status
  }
}

function mapDispatchToProps (dispatch): DispatchProps {
  return {}
}

interface ContainerState {
}

class ContainerComponent extends React.Component<DetailsProps, ContainerState> {
  render () {
    const hasMainMenu = this.props.hub && this.props.hub.length > 1
    const extraCssClasses = this.props.extraCssClasses && this.props.extraCssClasses.length > 0
      ? ' ' + this.props.extraCssClasses.join(' ') : ''
    const groupIdClass = (this.props.currentHubItem &&
      this.props.currentHubItem.groupId &&
      ` tabitem-groupid-${this.props.currentHubItem.groupId}`) || ''

    return (

        <div
          ref={(node) => resizingComponent.setRef(node, 'widget')}
          className={'imbox-' +
          (this.props.name) +
          (groupIdClass) +
          (hasMainMenu ? ' hasMainMenu' : '') +
          (extraCssClasses) +
          (this.props.streamStatus === 'incall' ? ' imbox-incall' : '')}
        >
          {this.props.children}
          <MainMenu />
        </div>

    )
  }
}

const Container = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(ContainerComponent)

export {
  Container
}
